import { DropdownButton } from "@artprov/design-system";
import PropTypes from "prop-types";
import { useEffect, useMemo, useState, useCallback } from "react";
import * as sentry from "@sentry/browser";
import { getAcciones } from "@/services/compra.services.js";
import { useComprasAuth } from "@/common/hooks/useComprasAuth.js";

export default function ApprovalActions({
  data,
  onActionSelect,
  textButton = "Acciones",
}) {
  const { userDetails } = useComprasAuth();
  const [actions, setActions] = useState([]);
  const [loadingActions, setLoadingActions] = useState(false);

  useEffect(() => {
    if (!userDetails?.CENTRO_COSTO) {
      return;
    }

    const fetchApiActions = async () => {
      setLoadingActions(true);
      try {
        const response = await getAcciones(userDetails.CENTRO_COSTO);
        const actionsArray = Array.isArray(response)
          ? response
          : response?.acciones || response?.data || [];
        setActions(actionsArray);
      } catch (error) {
        sentry.captureException(error);
        setActions([]);
      } finally {
        setLoadingActions(false);
      }
    };
    fetchApiActions();
  }, [userDetails?.CENTRO_COSTO]);

  const handleDropdownClick = useCallback((action) => {
    if (typeof onActionSelect === "function") {
      onActionSelect(action);
    } else {
      console.info("Action selected:", action?.DESCRIPCION, action?.ID);
    }
  }, [onActionSelect]);

  const opcionesDelMenu = useMemo(() => {
    const estadoActual = String(data?.ESTADOCOMPROBANTE || '').toLowerCase();
    
    // Filtrar acciones según el estado actual
    const filteredActions = actions.filter((action) => {
      const descripcionAccion = String(action.DESCRIPCION || '').toLowerCase();
      
      // Si la factura está "En progreso", no mostrar la acción "En progreso"
      if (estadoActual === 'en progreso' && descripcionAccion === 'en progreso') {
        return false;
      }
      
      return true;
    });
    
    return filteredActions.map((action) => ({
      icon: "",
      opcion: action.DESCRIPCION,
      onClick: () => handleDropdownClick(action),
    }));
  }, [actions, handleDropdownClick, data?.ESTADOCOMPROBANTE]);

  const isInvoiceApproved = (() => {
    if (Array.isArray(data)) return false;
    const estado = String(data?.ESTADOCOMPROBANTE || '').toLowerCase();
    return estado.includes('aprob');
  })();

  const isInvoiceRejected = (() => {
    if (Array.isArray(data)) return false;
    const estado = String(data?.ESTADOCOMPROBANTE || '').toLowerCase();
    return estado.includes('rechaz');
  })();

  const isInvoiceCompras = (() => {
    if (Array.isArray(data)) return false;
    const estado = String(data?.ESTADOCOMPROBANTE || '').toLowerCase();
    return estado.includes('compras');
  })();

  const disabled =
    loadingActions ||
    !data ||
    (Array.isArray(data) ? data.length === 0 : false) ||
    isInvoiceApproved ||
    isInvoiceRejected ||
    isInvoiceCompras;

  return (
    <div className="relative z-[99] [&_ul]:min-w-[140px]">
      <DropdownButton
        disabled={disabled}
        textButton={textButton}
        menuOptions={opcionesDelMenu}
      />
    </div>
  );
}

ApprovalActions.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  onActionSelect: PropTypes.func,
  textButton: PropTypes.string,
};

